var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({ref:"textbox",attrs:{"contenteditable":"true"},on:{"input":function($event){_vm.$emit('update:content', $event.target.innerText)}}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }